import PropTypes from "prop-types"
import React, { Component } from "react"
import { connect } from "react-redux"
import { CodeTable, getCodeTableEntries } from "./codeTableAccess"
import { cityLabelFor, houseLabelFor, unitLabelFor, tenantLabelFor } from "./presentationFormatters"

class LhoHeaderText extends Component {
  static propTypes = {
    lhoRef: PropTypes.string.isRequired,
    property: PropTypes.object,
    house: PropTypes.object,
    unit: PropTypes.object,
    unitTypes: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  }

  render = () => {
    const { lhoRef, property, house, unit } = this.props
    if (unit) {
      const unitLabel = unitLabelFor(unit, this.props.unitTypes)
      const tenantLabel = tenantLabelFor(unit)
      return [prefixedRef(lhoRef), unitLabel && " - " + unitLabel, tenantLabel && " - " + tenantLabel]
    } else if (house) {
      const description = houseLabelFor(house)
      const cityLabel = cityLabelFor(house.address)
      return [prefixedRef(lhoRef), description && " - " + description, cityLabel && " - " + cityLabel]
    } else if (property) {
      const description = property.description
      const cityLabel = cityLabelFor(property)
      return [prefixedRef(lhoRef), description && " - " + description, cityLabel && " - " + cityLabel]
    } else {
      return prefixedRef(lhoRef)
    }
  }
}

/* istanbul ignore next */
function mapStateToProps(state, ownProps) {
  const props = {}

  props.unitTypes = getCodeTableEntries(state, CodeTable.unitTypes)

  const { lhoRef, property, house, unit } = ownProps
  const lhoItem = unit || house || property

  if (!lhoRef && lhoItem) {
    props.lhoRef = lhoItem.reference
  }

  if (lhoRef && !lhoItem) {
    const { property, house, unit } = getLhoItems(state, lhoRef)
    if (unit) props.unit = unit
    else if (house) props.house = house
    else if (property) props.property = property
  }

  return props
}

function getLhoItems(state, lhoRef) {
  const refParts = lhoRef ? lhoRef.split(".") : []
  const [lRef, hRef, oRef] = refParts.reduce(
    (refs, refPart, idx) => [...refs, idx === 0 ? refPart : refs[idx - 1] + "." + refPart],
    [],
  )

  const lhoData = state && state.home && state.home.lhoData

  let property, house, unit
  if (lRef) property = lhoData && lhoData.properties && lhoData.properties.find(p => p.reference === lRef)
  if (hRef) house = property && property.houses && property.houses.find(h => h.reference === hRef)
  if (oRef) unit = house && house.units && house.units.find(o => o.reference === oRef)

  return { property, house, unit }
}

function prefixedRef(lhoRef) {
  if (lhoRef) {
    const prefix = ["", "LG ", "HA ", "OB "][lhoRef.split(".").length]
    return <b key="ref">{prefix + lhoRef}</b>
  } else {
    return null
  }
}

export default connect(mapStateToProps)(LhoHeaderText)



// WEBPACK FOOTER //
// ./src/features/common/LhoHeaderText.js